/**
 * Project API Client
 * Handles all API calls for Project entities
 */

import { BaseApiClient, ApiResponse, RequestOptions } from './baseApiClient';
import { API_ENDPOINTS } from '../config/apiEndpoints';
import {
  Project,
  CreateProjectRequest,
  UpdateProjectRequest,
  StandardListRequest,
  GetByIdRequest,
  DeleteRequest,
} from '../types';

/**
 * Project API Client
 */
export class ProjectApiClient extends BaseApiClient {
  /**
   * Get all projects
   */
  async getAll(request: StandardListRequest = {}, options?: RequestOptions): Promise<ApiResponse<Project[]>> {
    return this.postQuery<Project[]>(API_ENDPOINTS.PROJECTS.LIST, request, options);
  }

  /**
   * Get project by ID
   */
  async getById(request: GetByIdRequest): Promise<ApiResponse<Project>> {
    return this.postQuery<Project>(API_ENDPOINTS.PROJECTS.GET_BY_ID, { ID: { ID: request.id } });
  }

  /**
   * Create project
   */
  async create(request: CreateProjectRequest): Promise<ApiResponse<Project>> {
    return this.post<Project>(API_ENDPOINTS.PROJECTS.CREATE, request);
  }

  /**
   * Update project
   */
  async update(request: UpdateProjectRequest): Promise<ApiResponse<Project>> {
    // C# API expects the full entity including ProjectID in the body
    // The controller validates that the ID in the body matches the ID in the route
    return this.put<Project>(API_ENDPOINTS.PROJECTS.UPDATE(request.ProjectID), request);
  }

  /**
   * Delete project
   */
  async deleteProject(request: DeleteRequest): Promise<ApiResponse<void>> {
    // C# API expects DeleteWebRequest with ID property
    const deleteRequestBody = {
      ID: {
        ID: request.id,
        ResID: '',
      },
    };
    return super.delete<void>(API_ENDPOINTS.PROJECTS.DELETE(request.id), deleteRequestBody);
  }
}

// Singleton instance
export const projectApiClient = new ProjectApiClient();
